import React, { Component } from "react";

const { Provider, Consumer } = React.createContext();

class InitCCProvider extends Component {
  state = {
    cardType: "",
    deposit: "",
    ewcc: "",
    cardno: "",
    ewRelConfirm: "",
    ewRelName: "",
    ewRelRelationship: "",
    ewPos: "",
    ewPEP: "",
    ewPEPRel: "",
    ewPEPRelName: "",
    ewPEPRelRelationship: "",
    // reference: "",
    // refothers: "",
    firstName: "",
    middleName: "",
    lastName: "",
    cardName: "",
    birthDate: "",
    birthPlace: "",
    momName: "",
    momName1: "",
    momName2: "",
    sex: "",
    civilStatus: "",
    numberDependents: "",
    numberCar: "",
    educ: "",
    citizenship1: "",
    citizenship: "",
    acr: "",
    tinNo: "",
    sssNo: "",
    homeAddress: "",
    zipCode: "",
    chkPermAddSameWithHomeAdd: "",
    permanentAddress: "",
    zipCode2: "",
    homeOwner: "",
    yearStay: "",
    homeAreaCode: "",
    homePhone: "",
    mobilePhone: "",
    emailAddress: "",
    emailAddressAlt: "",
    socMed: "",
    fundSrc: "",
    fundSrc1: "",
    workType: "",
    employment1: "",
    workYear: "",
    workPos: "",
    workPos1: "",
    workPos2: "",
    workNature: "",
    businessName: "",
    businessDept: "",
    businessAddress: "",
    businessZip: "",
    businessPhone: "",
    businessIncome: "",
    cardIssuer1: "",
    cardNumber1: "",
    memberSince1: "",
    creditLimit1: "",
    cardIssuer2: "",
    cardNumber2: "",
    memberSince2: "",
    creditLimit2: "",
    // cardIssuer3: "",
    // cardNumber3: "",
    // memberSince3: "",
    // creditLimit3: "",
    spouseName: "",
    spouseBusiness: "",
    spousePosition: "",
    spouseDept: "",
    spouseAddress: "",
    spouseZip: "",
    spousePhone: "",
    spouseAreaCode: "",
    spouseCP: "",
    spouseIncome: "",
    friendName: "",
    friendBusiness: "",
    friendPosition: "",
    friendDept: "",
    friendPhone: "",
    delivery: "",
    SOAtoBillingAdd: "",
    notARobot: "",
    consentOther: true
  };

  render() {
    return (
      <Provider
        value={{
          cardType: this.state.cardType,
          deposit: this.state.deposit,
          ewcc: this.state.ewcc,
          cardno: this.state.cardno,
          ewRelConfirm: this.state.ewRelConfirm,
          ewRelName: this.state.ewRelName,
          ewRelRelationship: this.state.ewRelRelationship,
          ewPos: this.state.ewPos,
          ewPEP: this.state.ewPEP,
          ewPEPRel: this.state.ewPEPRel,
          ewPEPRelName: this.state.ewPEPRelName,
          ewPEPRelRelationship: this.state.ewPEPRelRelationship,
          // reference: this.state.reference,
          // refothers: this.state.refothers,
          firstName: this.state.firstName,
          middleName: this.state.middleName,
          lastName: this.state.lastName,
          cardName: this.state.cardName,
          birthDate: this.state.birthDate,
          birthPlace: this.state.birthPlace,
          momName: this.state.momName,
          momName1: this.state.momName1,
          momName2: this.state.momName2,
          sex: this.state.sex,
          civilStatus: this.state.civilStatus,
          numberDependents: this.state.numberDependents,
          numberCar: this.state.numberCar,
          educ: this.state.educ,
          citizenship1: this.state.citizenship1,
          citizenship: this.state.citizenship,
          acr: this.state.acr,
          tinNo: this.state.tinNo,
          sssNo: this.state.sssNo,
          homeAddress: this.state.homeAddress,
          zipCode: this.state.zipCode,
          chkPermAddSameWithHomeAdd: this.state.chkPermAddSameWithHomeAdd,
          permanentAddress: this.state.permanentAddress,
          zipCode2: this.state.zipCode2,
          homeOwner: this.state.homeOwner,
          yearStay: this.state.yearStay,
          homeAreaCode: this.state.homeAreaCode,
          homePhone: this.state.homePhone,
          mobilePhone: this.state.mobilePhone,
          emailAddress: this.state.emailAddress,
          socMed: this.state.socMed,
          emailAddressAlt: this.state.emailAddressAlt,
          fundSrc: this.state.fundSrc,
          fundSrc1: this.state.fundSrc1,
          workType: this.state.workType,
          employment1: this.state.employment1,
          workYear: this.state.workYear,
          workPos: this.state.workPos,
          workPos1: this.state.workPos1,
          workPos2: this.state.workPos2,
          workNature: this.state.workNature,
          businessName: this.state.businessName,
          businessDept: this.state.businessDept,
          businessAddress: this.state.businessAddress,
          businessZip: this.state.businessZip,
          businessPhone: this.state.businessPhone,
          businessIncome: this.state.businessIncome,
          cardIssuer1: this.state.cardIssuer1,
          cardNumber1: this.state.cardNumber1,
          memberSince1: this.state.memberSince1,
          creditLimit1: this.state.creditLimit1,
          cardIssuer2: this.state.cardIssuer2,
          cardNumber2: this.state.cardNumber2,
          memberSince2: this.state.memberSince2,
          creditLimit2: this.state.creditLimit2,
          // cardIssuer3: this.state.cardIssuer3,
          // cardNumber3: this.state.cardNumber3,
          // memberSince3: this.state.memberSince3,
          // creditLimit3: this.state.creditLimit3,
          spouseName: this.state.spouseName,
          spouseBusiness: this.state.spouseBusiness,
          spousePosition: this.state.spousePosition,
          spouseDept: this.state.spouseDept,
          spouseAddress: this.state.spouseAddress,
          spouseZip: this.state.spouseZip,
          spousePhone: this.state.spousePhone,
          spouseAreaCode: this.state.spouseAreaCode,
          spouseCP: this.state.spouseCP,
          spouseIncome: this.state.spouseIncome,
          friendName: this.state.friendName,
          friendBusiness: this.state.friendBusiness,
          friendPosition: this.state.friendPosition,
          friendDept: this.state.friendDept,
          friendPhone: this.state.friendPhone,
          delivery: this.state.delivery,
          SOAtoBillingAdd: this.state.SOAtoBillingAdd,
          consentOther: this.state.consentOther,
          handleInputChange: event => {
            const target = event.target;
            const value = target.value;
            const fname = target.name;

            this.setState({
              [fname]: value
            });
          },
          updateState: (sname, inval) => {
            this.setState({
              [sname]: inval
            });
          },
          resetForm: () => {
            this.setState({
              cardType: "",
              deposit: "",
              ewcc: "",
              cardno: "",
              ewRelConfirm: "",
              ewRelName: "",
              ewRelRelationship: "",
              ewPos: "",
              ewPEP: "",
              ewPEPRel: "",
              ewPEPRelName: "",
              ewPEPRelRelationship: "",
              // reference: "",
              // refothers: "",
              firstName: "",
              middleName: "",
              lastName: "",
              cardName: "",
              birthDate: "",
              birthPlace: "",
              momName: "",
              momName1: "",
              momName2: "",
              sex: "",
              civilStatus: "",
              numberDependents: "",
              numberCar: "",
              educ: "",
              citizenship1: "",
              citizenship: "",
              acr: "",
              tinNo: "",
              sssNo: "",
              homeAddress: "",
              zipCode: "",
              chkPermAddSameWithHomeAdd: "",
              permanentAddress: "",
              zipCode2: "",
              homeOwner: "",
              yearStay: "",
              homeAreaCode: "",
              homePhone: "",
              mobilePhone: "",
              emailAddress: "",
              emailAddressAlt: "",
              socMed: "",
              fundSrc: "",
              fundSrc1: "",
              workType: "",
              employment1: "",
              workYear: "",
              workPos: "",
              workPos1: "",
              workPos2: "",
              workNature: "",
              businessName: "",
              businessDept: "",
              businessAddress: "",
              businessZip: "",
              businessPhone: "",
              businessIncome: "",
              cardIssuer1: "",
              cardNumber1: "",
              memberSince1: "",
              creditLimit1: "",
              cardIssuer2: "",
              cardNumber2: "",
              memberSince2: "",
              creditLimit2: "",
              // cardIssuer3: "",
              // cardNumber3: "",
              // memberSince3: "",
              // creditLimit3: "",
              spouseName: "",
              spouseBusiness: "",
              spousePosition: "",
              spouseDept: "",
              spouseAddress: "",
              spouseZip: "",
              spousePhone: "",
              spouseAreaCode: "",
              spouseCP: "",
              spouseIncome: "",
              friendName: "",
              friendBusiness: "",
              friendPosition: "",
              friendDept: "",
              friendPhone: "",
              delivery: "",
              SOAtoBillingAdd: "",
              consentOther: true
              // :''
            });
          }
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { InitCCProvider, Consumer };
